module.exports = __webpack_public_path__ + "static/media/westinchennai05.62f80f6b.jpg";